import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';

// 页面组件
import Login from '@pages/Login/Login';
import Register from '@pages/Register/Register';
import Home from '@pages/Home/Home';
import Dashboard from '@pages/Dashboard/Dashboard';
import Docs from '@pages/Docs/Docs';
import GroupManage from '@pages/GroupManage/GroupManage';
import GroupJoinDoc from '@pages/GroupJoinDoc/GroupJoinDoc';
import CreateGroup from '@pages/CreateGroup/CreateGroup';
import EditGroup from '@pages/EditGroup/EditGroup';
import Settings from '@pages/Settings/Settings';

import AdminLogin from '@pages/Admin/AdminLogin';
import AdminDashboard from '@pages/Admin/AdminDashboard';

// 布局组件
import Layout from '@components/Layout/Layout';

// 文档路由 - 已登录显示 Layout 左侧栏，未登录直接展示文档页面
function DocsRoute() {
  const { isAuthenticated } = useAuthStore();
  if (isAuthenticated) {
    return <Layout><Docs /></Layout>;
  }
  return <Docs />;
}

// 认证保护路由
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <Routes>
      {/* 公开路由 */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/docs" element={<DocsRoute />} />

      {/* 加群指引 - 公开访问 */}
      <Route path="/groups/:id/join" element={<GroupJoinDoc />} />

      {/* 保护路由 */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/groups/new" element={<ProtectedRoute><CreateGroup /></ProtectedRoute>} />
      <Route path="/groups/:id" element={<ProtectedRoute><GroupManage /></ProtectedRoute>} />
      <Route path="/groups/:id/edit" element={<ProtectedRoute><EditGroup /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

      {/* 超级管理员路由 */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />

      {/* 默认重定向 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
